export default "__VITE_ASSET__CTlWjOvg__"